<template>
  <pattern
    :id="`${id}-radar-chart__pattern-ascending`"
    x="0"
    y="0"
    :width="56 * u"
    :height="25 * u"
    patternUnits="userSpaceOnUse"
  >
    <rect :width="56 * u" :height="25 * u" fill="rgba(180,255,180,0.1)" />
    <path
      :d="`M${4 * u},${24 * u} L${14 * u},${14 * u} L${24 * u},${24 * u} L${
        24 * u
      },${12 * u} L${14 * u},${2 * u} L${4 * u},${12 * u}`"
      stroke="none"
      fill="rgba(255,255,255,0.5)"
    />
    <path
      :d="`M${32 * u},${36 * u} L${42 * u},${26 * u} L${52 * u},${36 * u} L${
        52 * u
      },${24 * u} L${42 * u},${14 * u} L${32 * u},${24 * u}`"
      stroke="none"
      fill="rgba(255,255,255,0.5)"
    />
    <path
      :d="`M${32 * u},${11 * u} L${42 * u},${1 * u} L${52 * u},${11 * u} L${
        52 * u
      },${-1 * u} L${42 * u},${-11 * u} L${32 * u},${-1 * u}`"
      stroke="none"
      fill="rgba(255,255,255,0.5)"
    />
  </pattern>
  <pattern
    :id="`${id}-radar-chart__pattern-descending`"
    x="0"
    y="0"
    :width="56 * u"
    :height="25 * u"
    patternUnits="userSpaceOnUse"
  >
    <rect :width="56 * u" :height="25 * u" fill="rgba(255,255,255,0.75)" />
    <path
      :d="`M${4 * u},${2 * u} L${14 * u},${12 * u} L${24 * u},${2 * u} L${
        24 * u
      },${12 * u} L${14 * u},${22 * u} L${4 * u},${12 * u}`"
      stroke="none"
      fill="rgba(255,255,255,0.6)"
    />
    <path
      :d="`M${32 * u},${14 * u} L${42 * u},${24 * u} L${52 * u},${14 * u} L${
        52 * u
      },${26 * u} L${42 * u},${36 * u} L${32 * u},${26 * u}`"
      stroke="none"
      fill="rgba(255,255,255,0.6)"
    />
    <path
      :d="`M${32 * u},${-12 * u} L${42 * u},${-2 * u} L${52 * u},${-12 * u} L${
        52 * u
      },${1 * u} L${42 * u},${11 * u} L${32 * u},${1 * u}`"
      stroke="none"
      fill="rgba(255,255,255,0.6)"
    />
  </pattern>
  <pattern
    :id="`${id}-radar-chart__pattern-descending--colored`"
    x="0"
    y="0"
    :width="56 * u"
    :height="25 * u"
    patternUnits="userSpaceOnUse"
  >
    <rect x="0" y="0" width="100%" height="100%" fill="red" />
    <rect
      x="0"
      y="0"
      width="100%"
      height="100%"
      :fill="`url(#${id}-radar-chart__pattern-descending)`"
    />
  </pattern>
  <pattern
    :id="`${id}-radar-chart__pattern-ascending--colored`"
    x="0"
    y="0"
    :width="56 * u"
    :height="25 * u"
    patternUnits="userSpaceOnUse"
  >
    <rect x="0" y="0" width="100%" height="100%" fill="#bbe3c9" />
    <rect
      x="0"
      y="0"
      width="100%"
      height="100%"
      :fill="`url(#${id}-radar-chart__pattern-ascending)`"
    />
  </pattern>
</template>

<script setup lang="ts">
defineProps<{
  id: string;
  u: number;
}>();
</script>
